module.exports = __webpack_public_path__ + "static/media/google_chat_logo.9768c029.svg";